<template>
    <div class="container-with-elements">
        <p><label class="form-label">{{$t('utils.date')}}:</label> {{ elementDate | date }}</p>
        <hour-field
            ref="hourfield"
            :value="element.values.date"
            :field="novoeightTreatmentFields.date"
            :prefix-field-name="prefix"
            :errors="errors"
            :label="$t('utils.hour')"
            field-name="date"
            time
            @input="addTimeToDate"
        />
        <input-field
            v-model="element.values.total_dose"
            :field="novoeightTreatmentFields.total_dose"
            :prefix-field-name="prefix"
            :errors="errors"
            field-name="total_dose"
            type="number"
            show-help-as-unit
        >
            <template v-slot:unit>
                {{ novoeightTreatmentFields.total_dose.help_text }} |
                {{ calculateDosePerKg(element.values.total_dose, surgery.weight) | numberOrEmpty }}
                {{ $t('utils.FVIIPerKgUnit') }}
            </template>
        </input-field>
        <select-as-radio-field
            v-model="element.values.administration"
            :field="novoeightTreatmentFields.administration"
            :choices="novoeightTreatmentFields.administration.choices"
            :prefix-field-name="prefix"
            :errors="errors"
            field-name="administration"
            show-help-as-unit
        />

        <input-field
            v-if="element.values.administration === 'continuous_infusion'"
            v-model="element.values.administration_infusion"
            :field="novoeightTreatmentFields.administration_infusion"
            :prefix-field-name="prefix"
            :errors="errors"
            :label="$t('novoeight.continuous_infusion_units')"
            field-name="administration_infusion"
            type="number"
            show-help-as-unit
        />

        <select-as-radio-field
            v-model="element.values.reason"
            :field="novoeightTreatmentFields.reason"
            :choices="novoeightTreatmentFields.reason.choices"
            :prefix-field-name="prefix"
            :errors="errors"
            field-name="reason"
            show-help-as-unit
        />
        <p v-if="serverErrors" class="invalid-feedback d-inline-block">{{ serverErrors }}</p>
        <create-cancel-buttons
            :ok-title="saveButtonTitle"
            :ok-function="checkAndSave"
            :cancel-title="$t('utils.cancel')"
            :cancel-function="close"
        />
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import DetailSurgeryElementMixin from "@/components/surgery/detail/elements/DetailSurgeryElementMixin";
    import InputField from "@/components/fields/InputField";
    import HourField from "@/components/fields/HourField";
    import {required} from "vuelidate/lib/validators";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import CreateCancelButtons from "@/components/surgery/detail/elements/CreateCancelButtons";
    import {calculateDosePerKg} from "@/components/surgery/SurgeryUtils";

    export default {
        name: "DetailSurgeryNovoeight",
        components: {CreateCancelButtons, SelectAsRadioField, HourField, InputField},
        mixins: [DetailSurgeryElementMixin],
        computed: {
            ...mapState(['novoeightTreatmentFields', 'surgery']),
            errors() {
                let errors = {};
                if (this.$v.element.values.total_dose.$error) {
                    errors['total_dose'] = [this.$t('error.required')];
                }
                return errors;
            }
        },
        created() {
            this.prefix = 'treatment-' + this.element.values.id;
            this.updateFunction = this.updateNovoeightTreatment;
            this.createFunction = this.createNovoeightTreatment;
        },
        methods: {
            ...mapActions([
                'updateNovoeightTreatment',
                'createNovoeightTreatment',
            ]),
            checkAndSave() {
                this.$refs.hourfield.createDate();
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.save();
                }
            },
            calculateDosePerKg,
        },
        validations: {
            element: {
                values: {
                    date: {
                        required,
                        validDate: function () {
                            return !this.$refs.hourfield.$v.$invalid;
                        },
                    },
                    total_dose: {
                        required
                    },
                }
            }
        }
    };
</script>

<style scoped>
</style>